import { Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { Deviation } from "./deviationsApi"
import { ClassificationChip, StatusChip } from "./Utils"

interface DeviationsTableProps {
    items: Deviation[]
}
 export const DeviationsTable = (props: DeviationsTableProps) => {
    const { items } = props

    return <TableContainer component={Paper} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Table size="small" stickyHeader>
            <TableHead>
                <TableRow>
                    {/* <TableCell width={56}><b>#</b></TableCell> */}
                    <TableCell width={200}><b>Nr odchylenia</b></TableCell>
                    <TableCell><b>Oczekiwany rezultat</b></TableCell>
                    <TableCell><b>Rzeczywisty rezultat</b></TableCell>
                    <TableCell width={160}><b>Klasyfikacja</b></TableCell>
                    <TableCell width={160}><b>Status</b></TableCell>
                </TableRow>
            </TableHead>
                {items.map(d => <TableRow>
                        <TableCell>{`Odchylenie ${d.order}`}</TableCell>
                        <TableCell>{d.expectedResult}</TableCell>
                        <TableCell>{d.actualResult}</TableCell>
						<TableCell>
							<ClassificationChip value={d.classification} />
						</TableCell>
                        <TableCell>
							<StatusChip status={d.status} />
                        </TableCell>
                    </TableRow>)}
            <TableBody>
            </TableBody>
        </Table>
    </TableContainer>
 }
